import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function alarmeSistema(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@turno/FIND_DATA':
      case '@turno/UPDATE_DATA':
      case '@turno/DELETE_DATA':
      case '@turno/STORE_DATA':
      case '@turno/DATA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@turno/SUCCESS_REMOVE':
      case '@turno/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@turno/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.data;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@turno/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.data;
        break;
      }

      case '@turno/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      case '@turno/CHANGE_PHYSICAL_TANK_DATA': {
        const tanques = [...state.find.tanques];
        tanques[action.payload.key] = action.payload.value;

        draft.find = {
          ...state.find,
          tanques,
        };
        break;
      }

      case '@turno/CHANGE_CLOSING_DATA': {
        const bicos = [...state.find.bicos];
        bicos[action.payload.key] = action.payload.value;

        draft.find = {
          ...state.find,
          bicos,
        };
        break;
      }

      default:
    }
  });
}
